import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import applyMiddleware from './applyMiddleware'
import HistoryStack from './historyStack'
import { initRoutesMeta } from './util'
import { captureTencentAttribution, buildCleanShareLink } from '../utils/tencentAttribution'

initRoutesMeta(routes)

const router = new Router({
    // mode: 'history',
    routes
})

router.stack = new HistoryStack()

router.beforeEach((to, from, next) => {
    const rawUrl = window.location.href
    console.log('rawUrl', rawUrl)

    try {
        captureTencentAttribution(rawUrl)
    } catch (e) {
        console.log(e)
    }

    const cleanUrl = buildCleanShareLink(rawUrl)

    //  改地址并刷新
    if (cleanUrl && cleanUrl !== rawUrl) {
        window.location.replace(cleanUrl)

        // window.history.replaceState(null, document.title, cleanUrl)
    }

    next()
})

Vue.use(Router)
applyMiddleware(router)

export default router
